<template>
    <ul>
        <li>
            <span class="semibold">Model</span>

            <select id="product-select" v-model="data.product_model">
                <option value="" disabled>Please select a product</option>
                <optgroup v-for="groupData in vg_get_main_product_group" :key="groupData.group" :label="groupData.group_name">
                    <option v-for="productKey in Object.keys(groupData.products)" :key="productKey" :value="groupData.products[productKey].sku">
                        {{ groupData.products[productKey].name }}
                    </option>
                </optgroup>
            </select>
            <!-- <select v-model="data.product_model">
                <option value="">Select model</option>
                <option v-bind:key="'model_' + index" v-for="(model, index) in vg_get_main_product" :value="model.sku">{{ model.name }}</option>
            </select> -->
        </li>
        <li>
            <span class="semibold mb-1">Serial number</span>
            <em v-if="data.serial_number.length == 5 && data.product_model == 'OD30DH'" style="font-size: 13px"
                >(please add a "0" after batch number so your code has 6 digits.)</em
            ><span>
                <em v-if="data.serial_number.length == 5 && data.product_model == 'OD30DH'" style="font-weight: 300; font-size: 12px">
                    Eg if your serial number is OD30DH - <strong style="font-size: 14px" class="text-red">23 001</strong> : you need to add a "0:
                    after the "3" OD30DH - <strong style="font-size: 14px" class="text-green">230 001</strong></em
                >
                <div class="serial-no-box">
                    <div class="order-number-wrap" v-if="data.hasOrderNumber">
                        <input type="text" :maxlength="4" v-model="data.order_number" placeholder="Order Number" class="order-number-input" />
                    </div>
                    <p class="serial-sku">{{ (data.hasOrderNumber ? '- ' : '') + (data.sku_number ? data.sku_number + ' - ' : '') }}</p>
                    <input
                        :maxlength="serial_number_max_length"
                        placeholder="Serial Number"
                        type="text"
                        v-model="data.serial_number"
                        class="serial-number-input"
                    />
                </div>
            </span>
        </li>
    </ul>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    props: ['data'],
    data() {
        return {
            serial_number_max_length: 8
        };
    },
    computed: {
        ...mapGetters({
            vg_get_main_product_key_val: 'mainproduct/list',
            vg_get_main_product: 'mainproduct/listArray',
            vg_get_main_product_group: 'mainproduct/listGroup'
        })
    },
    watch: {
        'data.product_model'(value) {
            const self = this;
            this.data.order_number = '';
            this.data.serial_number = '';
            this.data.sku_number = '';
            setTimeout(() => {
                if (value) {
                    // set blank and add
                    console.log(self.vg_get_main_product_key_val[value]);
                    self.data.sku_number = self.vg_get_main_product_key_val[value].sku;
                    self.serial_number_max_length = self.vg_get_main_product_key_val[value].sn_length;
                    self.data.hasOrderNumber = self.vg_get_main_product_key_val[value].has_order_number;
                } else {
                    self.data.serial_number = '';
                    self.data.sku_number = '';
                    self.data.hasOrderNumber = false;
                }
            }, 100);
        }
    }
};
</script>
